import { Shadows } from './interfaces'

export const shadows: Shadows = {
  s: '0 1px 1px 0 rgba(38, 38, 40, 0.08)',
  m: '0 2px 4px 0 rgba(38, 38, 40, 0.06)',
  l: '0 1px 4px 0 rgba(38,38,40,0.08), 0 4px 12px 2px rgba(38,38,40,0.12)',
}
